<template>
    <div v-if="filtersLoaded">
        <div class="exhibitor-list">
            <div class="filters d-block d-md-none">
                <div class="d-flex justify-content-between mb-2">
                    <button class="btn btn-outline-primary btn-sm flex-grow-1 me-2" @click="toggleFilter('alphabet')">{{ __('Filter by alphabet') }}</button>
                    <button class="btn btn-outline-primary btn-sm flex-grow-1 position-relative" @click="toggleFilter('sector')" v-if="sectors.length > 1">{{ __('Filter by sector') }} <span class="small bg-gray position-absolute rounded-circle" style="top: -10px; right: -5px; width: 20px; height: 20px;" v-if="activeSectorIds && activeSectorIds.length && activeSectorIds.length != sectors.length">{{ activeSectorIds.length }}</span></button>
                    <button class="btn btn-outline-primary btn-sm flex-grow-1 ms-2" @click="toggleFilter('sort')">{{ __('Sort') }}</button>
                </div>
                <div v-if="activeFilter == 'alphabet'" class="bg-gray p-3 mb-4">
                    <ul class="alphabet mb-0">
                        <li v-for="letter in letters" @click="toggleLetter(letter); storeFilters()" :style="{ opacity : activeLetter && activeLetter != letter ? 0.3 : null }" :class="{ 'fw-bold' : activeLetter == letter } ">{{ letter }}</li>
                    </ul>
                    <div class="mt-2">
                        <a href="#" @click.prevent="showAllLetters(); storeFilters()" class="small">{{ __('Show all letters') }}</a>
                    </div>
                </div>
                <div v-if="activeFilter == 'sector'" class="bg-gray p-3 mb-4">
                    <span class="badge me-1 clickable" :style="sectorClass(sector)" v-for="sector in sectors" @click="toggleSector(sector); storeFilters()">{{ sector.label[_locale] ? sector.label[_locale] : '' }}</span>
                    <div class="mt-2">
                        <a href="#" @click.prevent="showAllSectors(); storeFilters()" class="small">{{ __('Show all sectors') }}</a>
                    </div>
                </div>
                <div v-if="activeFilter == 'sort'" class="bg-gray p-3 mb-4">
                    <div class="d-flex">
                        <div class="border-end">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="order_by_mobile" id="orderByAlphabetMobile" value="alphabet" v-model="orderBy" @change="storeFilters">
                                <label class="form-check-label" for="orderByAlphabetMobile">{{ __('Alphabet') }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="order_by_mobile" id="orderByStandMobile" value="stand" v-model="orderBy" @change="storeFilters">
                                <label class="form-check-label" for="orderByStandMobile">{{ __('Standnumber') }}</label>
                            </div>
                        </div>
                        <div class="ms-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="sort_order_mobile" id="sortOrderAscMobile" value="asc" v-model="sortOrder" @change="storeFilters">
                                <label class="form-check-label" for="sortOrderAscMobile">{{ __('Ascending') }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="sort_order_mobile" id="sortOrderDescMobile" value="desc" v-model="sortOrder" @change="storeFilters">
                                <label class="form-check-label" for="sortOrderDescMobile">{{ __('Descending') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="filters mb-3 d-none d-md-block">
                <div class="py-2 align-items-center">
                    <div class="label">
                        {{ __('Filter by alphabet') }}<br>
                        <a href="#" @click.prevent="showAllLetters(); storeFilters()" class="small">{{ __('Show all letters') }}</a>
                    </div>
                    <div class="w-100">
                        <ul class="alphabet mb-0">
                            <li v-for="letter in letters" @click="toggleLetter(letter); storeFilters()" :style="{ opacity : activeLetter && activeLetter != letter ? 0.3 : null }" :class="{ 'fw-bold' : activeLetter == letter, 'text-primary' : activeLetter == letter }">{{ letter }}</li>
                        </ul>
                    </div>
                </div>
                <div class="py-2" v-if="sectors.length > 1">
                    <div class="label">
                        {{ __('Filter by sector') }}<br>
                        <a href="#" @click.prevent="showAllSectors(); storeFilters()" class="small">{{ __('Show all sectors') }}</a>
                    </div>
                    <div>
                        <span class="badge me-1 clickable" :style="sectorClass(sector)" v-for="sector in sectors" @click="toggleSector(sector); storeFilters()">{{ sector.label[_locale] ? sector.label[_locale] : '' }}</span>
                    </div>
                </div>
                <div class="py-2">
                    <div class="label">
                        {{ __('Sort by') }}
                    </div>
                    <div class="d-flex">
                        <div class="border-end">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="order_by" id="orderByAlphabet" value="alphabet" v-model="orderBy" @change="storeFilters">
                                <label class="form-check-label" for="orderByAlphabet">{{ __('Alphabet') }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="order_by" id="orderByStand" value="stand" v-model="orderBy" @change="storeFilters">
                                <label class="form-check-label" for="orderByStand">{{ __('Standnumber') }}</label>
                            </div>
                        </div>
                        <div class="ms-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="sort_order" id="sortOrderAsc" value="asc" v-model="sortOrder" @change="storeFilters">
                                <label class="form-check-label" for="sortOrderAsc">{{ __('Ascending') }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="sort_order" id="sortOrderDesc" value="desc" v-model="sortOrder" @change="storeFilters">
                                <label class="form-check-label" for="sortOrderDesc">{{ __('Descending') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="exhibitors.length && favoriteUri" class="alert alert-secondary d-flex justify-content-between align-items-center flex-column flex-md-row" style="gap: 10px">
                <span v-html="__('Use the :icon-icon to add exhibitors to your favorite list', { icon : '<i class=&quot;fa fa-heart-o&quot;></i>' })" class="mb-2 mb-md-0"></span>
                <a :href="favoriteUri" class="btn btn-sm btn-primary text-white text-nowrap">{{ __('View favorite list') }} <i class="fa fa-angle-right"></i></a>
            </div>
            <div v-if="exhibitors.length == 0" class="alert alert-warning">
                <span v-if="activeLetter || (activeSectorIds.length && activeSectorIds.length != sectors.length)">{{ __('No results found') }}</span>
                <span v-else>{{ __('The list of exhibitors will appear here as soon as it is known') }}</span>
            </div>
            <div v-else class="mt-3">
                <div class="row">
                    <div class="col-sm-6 col-md-4 mb-3" v-for="exhibitor in exhibitors">
                        <exhibitor :exhibitor="exhibitor" :new-tab="openInNewTab"></exhibitor>
                    </div>
                </div>
                <observer @on-change="loadMoreButtonChange">
                    <div v-if="lastPage && lastPage > page" class="text-center">
                        <button class="btn btn-primary btn-lg text-white" @click.prevent="loadExhibitors(page+1)"><i class="fa fa-spin fa-circle-notch" v-if="loading"></i> {{ __('Load more results') }}</button>
                    </div>
                </observer>
            </div>
            <div v-if="exhibitors.length && favoriteUri && lastPage <= page && lastPage > 1" class="alert alert-secondary d-flex justify-content-between align-items-center flex-column flex-md-row">
                <span v-html="__('Use the :icon-icon to add exhibitors to your favorite list', { icon : '<i class=&quot;fa fa-heart-o&quot;></i>' })" class="mb-2 mb-md-0"></span>
                <a :href="favoriteUri" class="btn btn-sm btn-primary text-white">{{ __('View favorite list') }} <i class="fa fa-angle-right"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['favorite-uri', 'open-in-new-tab'],
        data() {
            return {
                sectors : [],
                activeSectorIds : [],
                loading: false,
                exhibitors : [],
                page : 1,
                lastPage : null,
                orderBy : 'alphabet',
                sortOrder : 'asc',
                filtersLoaded : false,
                activeLetter : null,
                activeFilter : null,
            }
        },
        methods: {
            reset() {
                this.loadExhibitors(1);
            },
            toggleLetter(letter) {
                if (this.activeLetter == letter) {
                    this.activeLetter = null;
                } else {
                    this.activeLetter = letter;
                }
            },
            loadMoreButtonChange(entry) {
                if (entry.isIntersecting) {
                    this.loadExhibitors(this.page+1);
                }
            },
            loadExhibitors(page) {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                axios.get(location.href, { params : { ajax: true, page: page }})
                     .then(response => {
                        if (page == 1) {
                            this.exhibitors = [];
                        }

                        if (!this.filtersLoaded && response.data.filters) {
                            this.sortOrder = response.data.filters.sort_order;
                            this.orderBy = response.data.filters.order_by;
                            this.activeSectorIds = response.data.filters.sector_ids;
                            this.activeLetter = response.data.filters.letter;

                            if (this.activeLetter) {
                                this.activeFilter = 'alphabet';
                            } else if (this.activeSectorIds && this.activeSectorIds.length && this.activeSectorIds.length != this.sectors.length) {
                                this.activeFilter = 'sector';
                            }
                        }

                        this.exhibitors = this.exhibitors.concat(response.data.pagination.data);
                        this.page = response.data.pagination.current_page;
                        this.lastPage = response.data.pagination.last_page;

                        this.loading = false;
                        this.filtersLoaded = true;
                     });
            },
            storeFilters() {
                axios.post('/exhibitors/filters', { order_by : this.orderBy, sort_order : this.sortOrder, sector_ids : this.activeSectorIds, letter : this.activeLetter })
                     .then(response => {
                         this.loadExhibitors(1);
                     });
            },
            loadSectors() {
                axios.get('/api/sectors')
                     .then(response => {
                         this.sectors = response.data;
                         this.showAllSectors();

                         this.loadExhibitors(1);
                     });
            },
            showAllSectors() {
                this.activeSectorIds = [];
                this.sectors.forEach(sector => {
                    this.activeSectorIds.push(sector.id);
                });
            },
            showAllLetters() {
                this.activeLetter = null;
            },
            toggleSector(sector) {
                // if all sectors are active and one is clicked, we want it to be the only one.
                if (this.activeSectorIds.length == this.sectors.length) {
                    this.activeSectorIds = [sector.id];
                    return;
                }

                var index = this.activeSectorIds.indexOf(sector.id);
                if (index !== -1) {
                    this.activeSectorIds.splice(index, 1);
                } else {
                    this.activeSectorIds.push(sector.id);
                }
            },
            toggleFilter(filter)
            {
                if (this.activeFilter == filter) {
                    this.activeFilter = null;
                    return;
                }

                this.activeFilter = filter;
            },
            sectorClass(sector) {
                if (!this.activeSectorIds.includes(sector.id)) {
                    return { backgroundColor : 'gray'};
                }

                var styles = {};

                if (sector.color) {
                    styles.backgroundColor = sector.color;
                }

                return styles;
            }
        },
        computed: {
            letters() {
                let letters = ['0-9'];
                for(let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {letters.push(String.fromCharCode([i]))}
                return letters
            }
        },
        mounted() {
            this.loadSectors();
        },
    }
</script>
